import { useQuery } from '@tanstack/react-query'
import { useSearchParams } from 'react-router-dom'
import { queryKeys, QUERY_CONFIG } from '../../lib/react-query'
import { sslApi } from '../../services/api'
import { useAuthStore } from '../../store/authStore'


/**
 * Hook for fetching paginated SSL certificates list
 * Automatically refetches when URL params change
 */
export function useSSL() {
  const orgId = useAuthStore((state) => state.orgId)
  const [searchParams] = useSearchParams()
  const params = searchParams.toString()

  return useQuery({
    queryKey: queryKeys.ssl.list(orgId, params),
    queryFn: () => sslApi.getList(params),
    enabled: !!orgId,
  })
}

/**
 * Hook for fetching SSL filter options
 * Cached for 15 minutes as these change less frequently
 */
export function useSSLFilterOptions() {
  const orgId = useAuthStore((state) => state.orgId)
  return useQuery({
    queryKey: queryKeys.ssl.filterOptions(orgId),
    queryFn: () => sslApi.getFilterOptions(),
    staleTime: QUERY_CONFIG.LISTS.staleTime,
    enabled: !!orgId,
  })
}

/**
 * Hook for fetching a single SSL certificate by ID
 */
export function useSSLDetail(id: string | null) {
  const orgId = useAuthStore((state) => state.orgId)
  return useQuery({
    queryKey: queryKeys.ssl.detail(orgId, id || ''),
    queryFn: () => sslApi.getById(id!),
    enabled: !!id && !!orgId,
  })
}
